export const ITEM_LEAD_TIME_AVAILABLE_NOW = 'available-now';

export const NEW_SELLER_SINCE_THRESHOLD = 6;

export const ITEM_IS_CUSTOMIZABLE_ATTRIBUTE_ID = '10973';

export const ITEM_IS_RING_RESIZABLE_ATTRIBUTE_ID = '79702';
